import css from "styled-jsx/css";
import { grid, colors } from "../constants";

export default css`
  .backround {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .linear-gradient {
      display: none;
    }

    @media screen and (min-width: ${grid.breakpoint_sm}px) {
      .linear-gradient {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.8) 100%
        );
        background-color: rgba(6, 111, 203, 0.25);
      }
    }
  }
`;
